function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationPin = function SvgLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.467,
    height: 16.733,
    viewBox: "0 0 2.769 4.427"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M119.51 116.724c-.137-.148-.196-.348-.302-.517-.297-.584-.582-1.173-.892-1.75-.181-.337-.152-.738-.128-1.108.023-.326.238-.613.488-.807.224-.17.505-.247.784-.233.284.007.596-.025.84.148.261.132.448.376.568.637.085.24.071.501.07.752a1.35 1.35 0 0 1-.169.668c-.183.346-.369.692-.538 1.045-.189.381-.38.762-.589 1.131a.105.105 0 0 1-.132.034zm.223-2.288c.426-.104.721-.613.531-1.025-.148-.365-.595-.59-.969-.435-.395.145-.635.647-.43 1.032.151.317.523.52.868.428",
    style: {
      fill: "gray",
      strokeWidth: 0.0115255
    },
    transform: "translate(-118.17 -112.308)"
  }));
};
export default SvgLocationPin;